import React, { useContext, useEffect, useState } from 'react';
import Button from 'components/Core/Button';
import HeaderNavContext from 'utils/HeaderNavContext';
import HyperLink from 'components/Core/HyperLink';
import MenuItem from '@mui/material/MenuItem';
import WebsiteImage from 'components/WebsiteImage';
import { navigationEvent } from 'services/dataLayerService';
import getViewAllCtaUrl from '../../utils/getViewAllCtaUrl';

import { SolutionsMenuContainer } from './styles';

const SolutionsMenu = ({ menu }) => {
  const { selectedContentType, setSelectedContentType } = useContext(HeaderNavContext);
  const [selectedType, setSelectedType] = useState(selectedContentType);
  const [clicked, setClicked] = useState(false);

  useEffect(() => {
    setSelectedContentType(selectedType);
    setClicked(true);
  }, [selectedType]);

  const getMenuItems = (type, group) =>
    menu.subNavigationElement.filter(
      (item) => item.businessType === type && item?.group?.group === group,
    );

  const cta = selectedContentType === 'Commercial' ? menu?.ctas?.[0] : menu?.ctas?.[1];

  const menuData = [
    {
      type: {
        title: 'Commercial',
        subtitle:
          'Power your business with a platform designed to give you workflows that encourage productivity.',
      },
      cols: [
        {
          title: 'By Value',
          menuItems: getMenuItems('Commercial', 'By Value'),
          class: 'value-commercial',
        },
        {
          title: 'By Features',
          menuItems: getMenuItems('Commercial', 'By Features'),
          class: 'features-commercial',
        },
      ],
    },
    {
      type: {
        title: 'Residential',
        subtitle:
          'Empower your team, gain more insights, and impress homeowners at every part of the job cycle.',
      },
      cols: [
        {
          title: 'By Value',
          menuItems: getMenuItems('Residential', 'By Value'),
          class: 'value-residential',
        },
        {
          title: 'By Features',
          menuItems: getMenuItems('Residential', 'By Features'),
          class: 'features-residential',
        },
      ],
    },
  ];

  return (
    <SolutionsMenuContainer>
      <div className="type-col">
        <div className="type-btns">
          <div
            className={`type-btns-bg ${selectedType.toLowerCase()} ${clicked ? 'clicked' : null}`}
          >
            <div className="type-btns-bg-triangle" />
          </div>
          {menuData.map((item, index) => {
            const type = item.type.title;

            return (
              <div
                className={`type-box ${type.toLowerCase()} ${
                  type === selectedType ? 'active' : 'inactive'
                }`}
                onClick={() => {
                  setClicked(true);
                  setSelectedType(type);
                  navigationEvent(item.type.title);
                }}
                key={`type-box-${index}`}
              >
                <h6>{item.type.title}</h6>
                <p>{item.type.subtitle}</p>
              </div>
            );
          })}
        </div>
        <div className="type-footer">
          <HyperLink
            href="/features/pro"
            className="header-menu-cta"
            data-position="Header - Menu Item CTA"
          >
            Upgrade to Pro Products
          </HyperLink>
        </div>
      </div>
      <div className="solutions-items-col">
        <div className="solutions-items-container">
          <div className="hr" />
          {menuData.map((item) =>
            item.cols.map((col, colIndex) => {
              const viewAllUrl = getViewAllCtaUrl(selectedType, col.title);

              return (
                <div
                  className={`item-col ${colIndex === 0 ? 'left' : 'right'} ${
                    item.type.title === selectedType ? 'show' : 'hide'
                  }`}
                  key={`item-col-${colIndex}`}
                >
                  <div className="group-title-container">
                    <h6 className="group-title">{col.title}</h6>
                    <HyperLink
                      href={viewAllUrl}
                      data-position="Header - Menu Item CTA"
                      className="header-menu-cta view-all-cta"
                    >
                      View All
                    </HyperLink>
                  </div>
                  {col.menuItems.map((item, index) => (
                    <MenuItem key={`menu-item-${colIndex}-${index}`}>
                      <HyperLink href={item.url} data-position="Header - Menu Item CTA">
                        <div className="nav-icon">
                          <WebsiteImage {...item.icon} />
                        </div>
                        <div className="nav-copy">
                          <h6>{item.label}</h6>
                          <p>{item.description}</p>
                        </div>
                      </HyperLink>
                    </MenuItem>
                  ))}
                </div>
              );
            }),
          )}
        </div>
        <div className="solutions-items-footer">
          <HyperLink
            href={cta?.url}
            className="header-menu-cta"
            data-position="Header - Menu Item CTA"
          >
            {cta?.buttonLabel}
          </HyperLink>
        </div>
      </div>
    </SolutionsMenuContainer>
  );
};

export default SolutionsMenu;
